/**
 * @deprecated This is no longer required, due to the usage of web-native `loading="lazy"` on relevant `img` tags.
 */
export default class LazyLoader {
    constructor(registerListeners: boolean = true) {
        if (registerListeners) {
            this.registerEventListeners();
        }

        this.registerLazyLoadTimer();
        this.lazyLoadImages();
    }

    registerEventListeners() {
        // On DOMContentLoaded, to ensure images already in viewport are loaded
        document.addEventListener("DOMContentLoaded", this.lazyLoadImages, false);

        // On any viewport change
        window.addEventListener("scroll", this.lazyLoadImages, false);
        window.addEventListener("resize", this.lazyLoadImages, false);
        window.addEventListener("orientationChange", this.lazyLoadImages, false);
    }

    registerLazyLoadTimer() {
        // @ts-ignore
        // Detect if current page is Elementor editor
        if (window.elementorFrontend && window.elementorFrontend.config.environmentMode.edit) {
            // Make sure images in editor are loaded
            window.setInterval(() => {
                this.lazyLoadImages();
            }, 250);
        }
    }

    lazyLoadImages() {
        // under-the-fold margin for tablet and pc
        let margin = 100;

        // under-the-fold margin for mobile
        if (window.innerWidth < 768) {
            margin = 10;
        }

        let lazyLoadImages: NodeListOf<HTMLImageElement> = document.querySelectorAll("img.lazy-load");

        lazyLoadImages.forEach((element: HTMLImageElement) => {
            if (element.src === undefined || element.src === "") {
                let distanceFromFold = element.getBoundingClientRect().top - window.innerHeight;
                if (distanceFromFold <= margin) {
                    let src = element.dataset.src;
                    if (src === undefined) {
                        return;
                    }

                    element.src = src.includes("%") ? decodeURI(src) : src;
                    element.removeAttribute("data-src");

                    if (element.dataset.srcset) {
                        let srcSet = element.dataset.srcset;
                        element.srcset = srcSet.includes("%") ? decodeURI(srcSet) : srcSet;
                        element.removeAttribute("data-srcset");
                    }
                }
            }
        });
    }
}
